import { Translations } from '../types';

export const es: Translations = {
  common: {
    loading: 'Cargando...',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    back: 'Volver',
    next: 'Siguiente',
    submit: 'Enviar',
    search: 'Buscar',
    filter: 'Filtrar',
    all: 'Todo',
    viewAll: 'Ver todo',
    copy: 'Copiar',
    copied: '¡Copiado!',
    success: 'Éxito',
    error: 'Error',
    close: 'Cerrar',
  },
  nav: {
    home: 'Inicio',
    linkExchange: 'Vincular Exchange',
    rebate: 'Reembolso',
    exchanges: 'Exchanges',
    withdraw: 'Retirar',
    history: 'Historial',
    checkIn: 'Check In',
    profile: 'Perfil',
    overview: 'Resumen',
    rewardHub: 'Centro de Recompensas',
    settings: 'Configuración',
  },
  dashboard: {
    title: '¡Bienvenido, {name}!',
    subtitle: 'Resumen de tu cuenta',
    balance: 'Saldo',
    totalEarned: 'Total Ganado',
    pendingRebate: 'Reembolso Pendiente',
    availablePoints: 'XP Disponible',
    recentRebates: 'Reembolsos Recientes',
    recentWithdrawals: 'Retiros Recientes',
  },
  linkExchange: {
    title: 'Vincular Cuenta de Exchange',
    subtitle: 'Conecta tu UID de exchange para habilitar el seguimiento automático de tarifas',
    exchange: 'Exchange',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: 'Vincular Cuenta',
    linkedAccounts: 'Cuentas Vinculadas',
    status: 'Estado',
    active: 'Activo',
    inactive: 'Inactivo',
    delete: 'Eliminar Cuenta',
    selectExchange: 'Seleccionar Exchange',
    enterUID: 'Ingresar UID',
    enterApiKey: 'Ingresar API Key',
    enterApiSecret: 'Ingresar API Secret',
    accountLinked: 'Cuenta vinculada exitosamente',
    accountDeleted: 'Cuenta eliminada exitosamente',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: 'Reembolso de Tarifas de Trading',
    subtitle: 'Historial de pagos de reembolso automático',
    totalRebate: 'Reembolso Total',
    pendingRebate: 'Reembolso Pendiente',
    balance: 'Saldo',
    withdraw: 'Retirar',
    rebateHistory: 'Historial de Reembolsos',
    date: 'Fecha',
    amount: 'Cantidad',
    status: 'Estado',
    completed: 'Completado',
    pending: 'Pendiente',
    failed: 'Fallido',
    description: 'Descripción',
    autoRebate: 'Reembolso Automático',
    autoRebateDesc: 'El sistema reembolsará automáticamente las tarifas de trading a tu cuenta. Tiempo de procesamiento: 1-3 días hábiles.',
  },
  withdraw: {
    title: 'Retirar',
    subtitle: 'Retirar fondos a tu billetera',
    availableBalance: 'Saldo Disponible',
    withdrawAmount: 'Cantidad a Retirar',
    walletAddress: 'Dirección de Billetera (o UID)',
    network: 'Red',
    selectNetwork: 'Seleccionar Red',
    enterAmount: 'Ingresar cantidad',
    enterWalletAddress: 'Ingresar dirección de billetera (o UID)',
    withdraw: 'Retirar',
    minWithdraw: 'Retiro mínimo: {amount}',
    fee: 'Tarifa',
    receiveAmount: 'Recibirás',
    withdrawHistory: 'Historial de Retiros',
    processing: 'Procesando',
    completed: 'Completado',
    failed: 'Fallido',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: 'Por favor ingresa una cantidad válida',
    pleaseEnterWallet: 'Por favor ingresa la dirección de billetera',
    pleaseSelectNetwork: 'Por favor selecciona una red',
    invalidAmount: 'Cantidad inválida',
    amountTooLow: 'Cantidad por debajo del retiro mínimo',
    insufficientBalance: 'Saldo insuficiente',
    confirmWithdrawal: 'Confirmar Retiro',
    withdrawalSubmitted: '¡Solicitud de retiro enviada exitosamente! Revisa el Historial para ver el estado.',
    withdrawalFailed: 'Retiro fallido',
    note: 'Nota',
    withdrawalNote: 'Las tarifas de gas se deducirán de la cantidad a retirar',
  },
  history: {
    title: 'Historial de Transacciones',
    subtitle: 'Ver todas tus transacciones y retiros',
    transactions: 'Transacciones',
    withdrawals: 'Retiros',
    rebates: 'Reembolsos',
    date: 'Fecha',
    type: 'Tipo',
    amount: 'Cantidad',
    status: 'Estado',
    noTransactions: 'No se encontraron transacciones',
    noWithdrawals: 'No se encontraron retiros',
    noRebates: 'No se encontraron reembolsos',
    claimNow: 'Reclamar Ahora',
    claiming: 'Reclamando...',
    readyToClaim: 'Listo para reclamar del contrato inteligente',
    claimedSuccessfully: '¡Reclamado exitosamente!',
    failedToClaim: 'Error al reclamar',
    noMoreItems: 'No hay más elementos',
    payGas: 'Pagar Gas',
    claimed: 'Reclamado',
    noHistoryFound: 'No se encontró historial',
    statusCompleted: 'Completado',
    statusPending: 'Pendiente',
    statusFailed: 'Fallido',
    statusProcessing: 'Procesando',
    statusRejected: 'Rechazado',
  },
  checkIn: {
    title: 'Check In Diario',
    subtitle: 'Haz check in diariamente para ganar puntos',
    checkIn: 'Check In',
    checkedIn: 'Check In Realizado',
    todayPoints: 'XP de Hoy',
    totalPoints: 'XP Total',
    points: 'XP',
    redeem: 'Canjear',
    rewards: 'Recompensas',
    vouchers: 'Vales',
    linkReward: 'Recompensa por Vincular',
    linkExchange: 'Vincular Cuenta de Exchange',
    linkRewardDesc: 'Vincula tu cuenta de exchange para recibir puntos de bonificación',
    rewardHistory: 'Historial de Recompensas',
    availableRewards: 'Recompensas Disponibles',
    voucher: 'Vale',
    gift: 'Regalo',
    pointsRequired: 'XP Requerido',
    redeemNow: 'Canjear Ahora',
    redeemed: 'Canjeado',
    noRewards: 'No hay recompensas disponibles',
    shop: 'Tienda',
    myCodes: 'Mis Códigos',
    backButton: '← Atrás',
    noPointsHistory: 'Sin historial de XP',
    myRedeemedCodes: 'Mis Códigos Canjeados',
    yourCode: 'Tu Código:',
    codeCopied: '¡Código copiado!',
    noRedeemedYet: 'Aún no hay recompensas canjeadas',
    dailyCheckIn: 'Check In Diario',
    tasks: 'Tareas',
    checkedInSuccessfully: '¡Check in exitoso!',
    checkInFailed: 'Check in fallido',
    claimedTask: '¡Tarea reclamada exitosamente!',
    failedToClaimTask: 'Error al reclamar tarea',
    insufficientPoints: 'XP insuficiente',
    redeemFailed: 'Canje fallido',
    special: 'Especial',
    social: 'Social',
    trading: 'Trading',
    watchAd: 'Ver Anuncio',
    available: 'disponible',
    completed: 'completado',
    comingSoon: 'Próximamente',
    times: 'veces',
    weeklyLeaderboard: 'Ranking XP Semanal',
    leaderboardSubtitle: 'Mejores actuaciones de esta semana',
    yourRank: 'Tu Posición',
    yourXP: 'Tu XP',
    you: 'Tú',
    noLeaderboardData: 'Aún no hay datos del ranking',
    prize: 'Premio',
  },
  profile: {
    title: 'Perfil',
    accountInfo: 'Información de la Cuenta',
    telegramId: 'Telegram ID',
    joinDate: 'Fecha de Registro',
    language: 'Idioma',
    english: 'Inglés',
    vietnamese: 'Vietnamita',
    spanish: 'Español',
    portuguese: 'Portugués',
    chinese: 'Chino',
    indonesian: 'Indonesio',
    emailSettings: 'Configuración de Email',
    notSet: 'No configurado',
    logout: 'Cerrar Sesión',
    logoutConfirm: '¿Estás seguro de que quieres cerrar sesión?',
  },
  login: {
    title: 'CashBackHub',
    subtitle: 'Sistema de Reembolso de Tarifas de Trading',
    description: 'Telegram Mini App',
    hint: 'Por favor, abre la aplicación desde Telegram',
    login: 'Iniciar Sesión',
  },
  exchanges: {
    title: 'Exchanges',
    subtitle: 'Elige tu tipo de referido',
    chooseReferralType: 'Elige tu tipo de referido',
    exchangeReferral: 'Referido de Exchange',
    linkYourUid: 'Vincula tu UID',
    copyTrade: 'Copy Trade',
    followTrades: 'Sigue nuestras operaciones',
    filterByExchange: 'Filtrar por exchange:',
    allExchanges: 'Todos los Exchanges',
    accounts: 'cuenta(s)',
    account: 'Cuenta',
    connected: 'Conectado',
    uidCopied: '¡UID copiado!',
    totalRebate: 'Reembolso Total',
    transactionVolume: 'Volumen de Transacciones',
    waitingForSync: 'Esperando sincronización',
    cashbackHubRebate: 'Reembolso CashbackHub',
    viewReason: 'Ver Motivo',
    reconnect: 'Reconectar',
    noAccounts: 'Aún no hay cuentas de exchange',
    rejectionReason: 'Motivo del Rechazo',
    exchangeConnected: '¡Exchange conectado exitosamente!',
    notConfigured: 'Aún no configurado',
    noExchangesAvailable: 'No Hay Exchanges Disponibles',
    pleaseContactSupport: 'Por favor contacta a nuestro equipo de soporte para configurar exchanges para tu cuenta.',
    allAccounts: 'Todas',
    activeAccounts: 'Activas',
    pendingAccounts: 'Pendientes',
    rejectedAccounts: 'Rechazadas',
    totalProfit: 'Beneficio Total',
    noCopyTradeAccounts: 'Aún no hay cuentas de copy trade',
    rejectionReasonText: 'Este UID no ha sido registrado bajo nuestro sistema de referidos. ¡Por favor contacta a nuestro equipo de soporte @backcashhub para obtener instrucciones detalladas sobre cómo completar el proceso de registro!',
  },
  settings: {
    title: 'Configuración',
    subtitle: 'Personaliza tu experiencia y gestiona los detalles de tu cuenta',
    telegramNotifications: 'Notificaciones de Telegram',
    profile: 'Perfil',
    telegramNotificationsDesc: 'Recibe actualizaciones instantáneas a través de Telegram',
    uid: 'UID',
    connected: 'Conectado',
    connect: 'Conectar',
    emailVerification: 'Verificación de Email',
    emailAddress: 'Dirección de Email',
    sendVerificationCode: 'Enviar Código de Verificación',
    sending: 'Enviando...',
    verificationCode: 'Código de Verificación',
    enterCode: 'Ingresa el código de 6 dígitos de tu email',
    changeEmail: 'Cambiar Email',
    resendCode: 'Reenviar Código',
    verifying: 'Verificando...',
    verifyEmail: 'Verificar Email',
    codeExpired: 'El código de verificación ha expirado. Por favor solicita uno nuevo.',
    invalidCode: 'Código de verificación inválido. Por favor intenta de nuevo.',
    verificationSent: '¡Código de verificación enviado exitosamente! Revisa tu email.',
    emailVerified: '¡Email verificado exitosamente!',
    failedToSend: 'Error al enviar el código de verificación. Por favor intenta de nuevo.',
    failedToVerify: 'Error al verificar el email. Por favor intenta de nuevo.',
    enterEmailPlaceholder: 'tu.email@example.com',
    enterCodeDesc: 'Ingresa el código de 6 dígitos de tu email',
  },
  copyTrade: {
    title: 'Copy Trade',
    notConfigured: 'Aún no configurado',
    noExchangesAvailable: 'No Hay Exchanges Disponibles',
    pleaseContactSupport: 'Por favor contacta a nuestro equipo de soporte para configurar exchanges para tu cuenta.',
    linkCopyTradeAccount: 'Vincular Cuenta de Copy Trade',
    selectExchange: 'Seleccionar Exchange',
    step1: 'Paso 1: Haz clic en el botón abajo para copy trade',
    openCopyTradeLink: 'Abrir Enlace de Copy Trade',
    clickToCopyTrade: 'Haz clic para abrir nuestro enlace de copy trade y sigue las instrucciones',
    step2: 'Paso 2: Ingresa Tu UID',
    enterYourUid: 'Ingresa Tu UID',
    enterUidPlaceholder: 'Ingresa tu UID en el exchange',
    submit: 'Enviar',
    submitting: 'Enviando...',
    pleaseEnterUid: 'Por favor ingresa tu UID',
    pleaseSelectExchange: 'Por favor selecciona un exchange',
    pleaseSelectBot: 'Por favor selecciona un bot',
    submittedSuccessfully: '¡Cuenta de copy trade enviada exitosamente! Espera la aprobación.',
    accountRejectedPleaseResubmit: 'Tu cuenta fue rechazada. Por favor, vuelve a enviar con información correcta.',
    disabled: 'Deshabilitado',
    accountDisabledMessage: 'Esta cuenta ha sido deshabilitada. Por favor, contacta con soporte para más información.',
    submitFailed: 'Error al enviar cuenta de copy trade',
  },
  rules: {
    title: 'Reglas de Reembolso',
    description: 'Porcentaje de reembolso basado en hitos de ganancias:',
    profitRange: 'Rango de Ganancias',
    rebatePercentage: 'Reembolso',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: 'El reembolso se calcula basado en las ganancias incrementales después de deducir el reembolso del exchange.',
    noRules: 'No hay reglas de reembolso disponibles',
  },
};

